import { useContext, useEffect, useState } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { canSendDirectoryMessage, debounce, formatFullName, getProfileMessagingDisabledTooltip, isEmpty } from '../../../library/Core/SmartFunctions';
import AlumniDirectoryService from './AlumniDirectoryService';

import SessionContext from '../../../library/Core/SessionContext';
import { SessionStateType } from '../../../library/Core/SmartTypes';
// import imgPursuingHigherStudies from '../../../styles/images/group-29476.svg';
// import { default as imgActiveAlumni, default as imgTotalJoinedAlumni } from '../../../styles/images/group-40733.svg';
//import imgWorkingAlumni from '../../../styles/images/group-41775.svg';
// import { default as imgFromYourBatch, default as imgPrestigiousCollege } from '../../../styles/images/mask-group-44.svg';
// import { default as imgSameNextLevelInterests, default as imgStudyingAbroad } from '../../../styles/images/mask-group-45.svg';
import CardBottom from './CardBottom';
import { getStudentImage } from '../../../common/styles/Images';
import { Tooltip } from 'bootstrap';
import { axiosClient } from '../../../library/Service/axiosClient';
import DirectorySearchControl, { handleClearAllFilterClick } from './DirectorySearchControl';

const imgPursuingHigherStudies = `${process.env.REACT_APP_IMAGE_BASEPATH}/pursuing-higher-studies.svg`;
const imgActiveAlumni = `${process.env.REACT_APP_IMAGE_BASEPATH}/group-40733.svg`;
const imgTotalJoinedAlumni = `${process.env.REACT_APP_IMAGE_BASEPATH}/mask-group-44.svg`;
const imgWorkingAlumni = `${process.env.REACT_APP_IMAGE_BASEPATH}/working-alumni.svg`;

const imgFromYourBatch = `${process.env.REACT_APP_IMAGE_BASEPATH}/from-your-batch.svg`;
const imgPrestigiousCollege = `${process.env.REACT_APP_IMAGE_BASEPATH}/from-prestigious-college.svg`;

const imgSameNextLevelInterests = `${process.env.REACT_APP_IMAGE_BASEPATH}/same-next-level-interests.svg`;
const imgStudyingAbroad = `${process.env.REACT_APP_IMAGE_BASEPATH}/alumni_globe.svg`;
const imgInTopCompanies = `${process.env.REACT_APP_IMAGE_BASEPATH}/in-top-companies.svg`;
const imgClaimedEntrepreneurs = `${process.env.REACT_APP_IMAGE_BASEPATH}/claimed-entrepreneurs.svg`;
const imgInLeadershipRoles = `${process.env.REACT_APP_IMAGE_BASEPATH}/in-leadership-roles.svg`;


const DirectorySummaryCardControl = () => {
    const { state, dispatch } = useContext(SmartContext);
    const { sessionState } = useContext(SessionContext);
    const { userTypeCode, instituteGroupId: schoolGroupId, primaryInstitute,instituteId } = sessionState as SessionStateType;
    const summaryCardsData = state.data.summary;
    const directoryLevel = state.data.searchLevel;
    const UserinstituteId = primaryInstitute ?? instituteId ;
    const instituteType = JSON.parse(state?.domain?.get('INSTITUTE_DOMAIN')?.find((element) => element.code == UserinstituteId)?.flexCol as string).institute_type;
    
    // const schoolId = sessionStorage.getItem('user-school-id');
    // const userTypeCode = sessionStorage.getItem('user-type-code') as string;
    // const schoolGroupId = sessionStorage.getItem('user-school-group-id');
    const [searchName, setSearchName] = useState('');
    const [showSuggestions, setShowSuggestions] = useState(false);

    const students = state.data.students || [];
    const searchLower = searchName.toLowerCase();
    const nameMap = new Map<string, any>();

    students.forEach((s: any) => {
        const fullName = (s.name || formatFullName(s.firstName, s.lastName)).trim();
        if (fullName && fullName.toLowerCase().includes(searchLower)) {
            nameMap.set(fullName, s);
        }
    });

    const suggestions = Array.from(nameMap.entries())
        .map(([text, s]) => ({
            id: `name-${s.uuid || s.id}`,
            text,
        }))
        .slice(0, 10);

    const cardsConfig = [
        {
            id: 'totalJoinedAlumni',
            label: 'Total Alumni',
            image: imgTotalJoinedAlumni,
            applicableForUserType: ['INSTITUTE_ADMIN', 'SCHOOL_ADMIN', 'STUDENT', 'ALUMNI'],
            applicableForInstituteType: ['SCHOOL','K12_SCHOOL','UNIVERSITY','DEEMED_UNIVERSITY'],
            tooltip: 'Count of alumni profiles available on the system',
        },
        // {
        //     id: 'activeAlumni',
        //     label: 'Total Accessible Alumni',
        //     image: imgActiveAlumni,
        //     applicableForUserType: ['INSTITUTE_ADMIN', 'STUDENT', 'ALUMNI'],
        //     applicableForInstituteType: ['ALL'],
        // },
        {
            id: 'pursuingHigherStudies',
            label: 'Pursuing Higher Studies',
            image: imgPursuingHigherStudies,
            applicableForUserType: ['INSTITUTE_ADMIN', 'SCHOOL_ADMIN', 'STUDENT', 'ALUMNI'],
            applicableForInstituteType: ['SCHOOL','K12_SCHOOL'],
        },
        { 
            id: 'workingAlumni', 
            label: 'Working Alumni', 
            image: imgWorkingAlumni, 
            applicableForUserType: ['INSTITUTE_ADMIN', 'SCHOOL_ADMIN', 'STUDENT', 'ALUMNI'],
            applicableForInstituteType: ['SCHOOL','K12_SCHOOL'],
        },
        { 
            id: 'fromYourBatch', 
            label: 'From Your Batch', 
            image: imgFromYourBatch, 
            applicableForUserType: ['ALUMNI'],
            applicableForInstituteType: ['SCHOOL','K12_SCHOOL','UNIVERSITY','DEEMED_UNIVERSITY'],
        },
        {
            id: 'fromPrestigiousCollege',
            label: 'From Prestigious College',
            image: imgPrestigiousCollege,
            applicableForUserType: ['INSTITUTE_ADMIN', 'SCHOOL_ADMIN', 'STUDENT'],
            applicableForInstituteType: ['SCHOOL','K12_SCHOOL'],
        },
        { 
            id: 'sameNextLevelInterests', 
            label: 'Same Next Level Interests', 
            image: imgSameNextLevelInterests, 
            applicableForUserType: [],
            applicableForInstituteType: [],
        },
        { 
            id: 'studyingAbroad', 
            label: 'Studied Abroad', 
            image: imgStudyingAbroad, 
            applicableForUserType: ['INSTITUTE_ADMIN', 'SCHOOL_ADMIN', 'STUDENT'],
            applicableForInstituteType: ['SCHOOL','K12_SCHOOL'],
        },
        
        { 
            id: 'settledAbroad', 
            label: 'Settled Abroad', 
            image: imgStudyingAbroad, 
            applicableForUserType: ['INSTITUTE_ADMIN', 'SCHOOL_ADMIN', 'ALUMNI', 'STUDENT'],
            applicableForInstituteType: ['UNIVERSITY','DEEMED_UNIVERSITY'],
            tooltip: 'Count of Alumni whose current location is outside India',
        },
        { 
            id: 'inTopCompany', 
            label: 'In Top Companies', 
            image: imgInTopCompanies, 
            applicableForUserType: ['INSTITUTE_ADMIN', 'SCHOOL_ADMIN', 'ALUMNI', 'STUDENT'],
            applicableForInstituteType: ['UNIVERSITY','DEEMED_UNIVERSITY'],
            tooltip: 'Alumni currently with top companies in their industry',
        },
        { 
            id: 'entrepreneurs', 
            label: 'Claimed Entrepreneurs', 
            image: imgClaimedEntrepreneurs, 
            applicableForUserType: ['INSTITUTE_ADMIN', 'SCHOOL_ADMIN', 'STUDENT'],
            applicableForInstituteType: ['UNIVERSITY','DEEMED_UNIVERSITY'],
            tooltip: 'Alumni whose profile information signifies that they are entrepreneurs',
        },
        { 
            id: 'inLeadershipRoles', 
            label: 'In Leadership Roles', 
            image: imgInLeadershipRoles, 
            applicableForUserType: ['INSTITUTE_ADMIN', 'SCHOOL_ADMIN', 'ALUMNI', 'STUDENT'],
            applicableForInstituteType: ['UNIVERSITY','DEEMED_UNIVERSITY'],
            tooltip: 'Alumni who are in decision making capacity for their organizations',
        }, 

    ];

    const summaryCardsControl = cardsConfig.filter((card) => (card.applicableForUserType.includes(userTypeCode) && card.applicableForInstituteType.includes(instituteType) || (card.id == 'settledAbroad' && userTypeCode == 'ALUMNI' && instituteType == 'SCHOOL')));

    const handleSummaryCardClick = (id: string) => {
        if (summaryCardsData[id] <= 0) {
            dispatch({ type: 'REFRESH_DATA', payload: { data: { ...state.data, students: [] } } });
            return;
        }

        // const searchCriteria = {
        //     ...AlumniDirectoryService.getCriteriaForSelectedCard(id, state),
        //     context: { searchBy: '', level: directoryLevel, selectedCard: id },
        // };

        const cardFiltersToBeRemoved = ['ugCollegeExists','isPursuingHigherStudies', 'isPrestigiousCollege', 'isStudyingAbroad', 'isSettledAbroad', 'isInTopCompany', 'isEntrepreneur', 'isInLeadershipRoles', 'isWorking'];
        const filters = Object.fromEntries(
            Object.entries(state?.data?.filters).filter(
              ([key]) => !cardFiltersToBeRemoved.includes(key)
            )
        );
          
        AlumniDirectoryService.performSearchWithUserSelectedCriteria({
            ...filters,
            context: { searchBy: '', level: directoryLevel, selectedCard: id },
            ...AlumniDirectoryService.getCriteriaForSelectedCard(id, state)
        }, state, dispatch);
    };

    const debouncedHandleNameSearch = debounce((value: string) => {
        const searchCriteria: any = { ...state?.data?.filters, name: value };
        AlumniDirectoryService.performSearchWithUserSelectedCriteria(searchCriteria, state, dispatch);
    }, 200);

    const handleSuggestionClick = (text: string) => {
        setSearchName(text);
        setShowSuggestions(false);
        debouncedHandleNameSearch(text);
    };

    const handleNameSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const val = event.target.value;
        setSearchName(val);
        setShowSuggestions(val.length > 0);
        debouncedHandleNameSearch(val);
    };

    const handleNameSearchClear = () => {
        setSearchName('');
        setShowSuggestions(false);
        debouncedHandleNameSearch('');
    };

    const handleInputBlur = () => {
        setTimeout(() => setShowSuggestions(false), 200);
    };

    const getCardBorder = (currentCard: string) => (currentCard === state.data.selectedCard ? 'active' : '');

    const [isShowSearch, setShowSearch] = useState(false);
    const [showResetButton, setshowResetButton] = useState(false);

    //Show/hide reset button based on filter changes
    useEffect(() => {
        if(JSON.stringify(state.data.filters) != JSON.stringify(AlumniDirectoryService.getDefaultSearchCriteria(''))){
            setshowResetButton(true);
        }
        else{
            setshowResetButton(false);
        }
    }, [state.data.filters]);

    useEffect(() => {
        const tooltipEls = [].slice.call(document.querySelectorAll('.defaultTooltip'));
        const tips = tooltipEls.map((el: Element) => new Tooltip(el));
        return () => tips.forEach((t: Tooltip) => t.dispose());
    });

    const handleSearchToggle = () => {
        setShowSearch(!isShowSearch);
    };

    const [isOpen, setOpen] = useState(false);

    const handleFilterToggle = () => {
        setOpen(!isOpen);
    };

    const handleSendMessage = (event: any, id: string) => {
        event.preventDefault();
        state.actions['ROUTER_NAVIGATE'](`/messages/${id}`);
    };

    const handleSendMessageMultiple = (event: any, uiid: any) => {
        if(uiid){
        // var uiid = uiid.join('/');
        updateNextBatchAlumni();
        event.preventDefault();
        state.actions['ROUTER_NAVIGATE'](`/messages/${uiid}`);
        }
    };

    const updateNextBatchAlumni = async () => {
        const user = JSON.parse(localStorage.getItem('user') as string);
        const studentId = user.studentId;
        try {
            const response = await axiosClient().get(`${process.env.REACT_APP_REPORTS_SERVER}/common/update-next-alumni-batch/${studentId}`);
        } catch (error) {
            console.log(error);
        }
    };

    const topAlumni = state.internal.getTopAlumni || [];
    const multipleUiid = topAlumni.map((alum: any) => alum.uuid).join('/');

    return (
        <>
            {userTypeCode === 'STUDENT' && !isEmpty(topAlumni) && (
                <div className="container-fluid bg-white">
                    <div className="max-1140 mx-auto py-4">
                        <div className="row g-3 header-title">
                            <div className="col-sm">
                                <div className="d-flex flex-wrap">
                                    <i className="icon_message me-2"></i>
                                    <div className="d-flex flex-column flex-1">
                                        <h3 className="mb-0">Question & Answer</h3>
                                        <p className="mb-0">
                                            Chat With The Alumni Who Matches Your Profile And Get Your Doubts Clarified For Your Career
                                            Ahead.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-auto">
                                <div className="d-flex flex-wrap align-items-center justify-content-end">
                                    <button className="btn btn-green me-2" type="button">
                                        <span onClick={(event) => handleSendMessageMultiple(event, multipleUiid)}>Send to All</span>
                                        <i className="icon-alumni-send position-relative ms-2 me-0"></i>
                                    </button>
                                    <i
                                        className="btn-md-filter icon-right-arrow cursor-pointer"
                                        onClick={handleFilterToggle}
                                        aria-expanded={isOpen ? 'true' : 'false'}></i>
                                </div>
                            </div>
                        </div>
                        <div className={`collapse mt-4 ${isOpen ? 'show' : ''}`} id="collapseExample">
                            <div className="row g-2 g-md-4 alumni-showcase">
                            {topAlumni && topAlumni.length > 0 ? (
                                <>
                                {topAlumni.map((alum: any) => (
                                
                                    <div className="col-lg-4 col-md-6 col-sm-6">
                                        <div className="alumni-bucket">
                                            <div className="alumni_class_link">
                                                <div className="alumni_name_detail">
                                                    <div className="alumni_img">
                                                        <a className="alumni_img_link" href="javascript:;">
                                                            <img src={getStudentImage(alum)} alt={`${alum.name}`} className="img-fluid" />
                                                        </a>
                                                    </div>
                                                    <div className="alumni_name_brife">
                                                        <h3>
                                                            <a className="alumni_name_link" href="javascript:;">
                                                                {alum.name}
                                                            </a>
                                                        </h3>
                                                        <span className="alumni_campus">
                                                            {alum.programName}, {alum.passOutYear}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="send_link">
                                                    {canSendDirectoryMessage(alum) ? (
                                                        <a
                                                            role="button"
                                                            onClick={(event) => handleSendMessage(event, alum.uuid)}
                                                            className="btn-send">
                                                            <i className="icon-alumni-send"></i>
                                                            <span>Send</span>
                                                        </a>
                                                    ) : (
                                                        <a
                                                            href="javascript:;"
                                                            className="btn-send btn-white-tooltip"
                                                            style={{ background: 'grey' }}
                                                            data-bs-toggle="tooltip"
                                                            data-bs-html="true"
                                                            data-bs-original-title={getProfileMessagingDisabledTooltip(alum)}>
                                                            <i className="icon-alumni-send"></i>
                                                            <span>Send</span>
                                                        </a>
                                                    )}
                                                    {/* <a href="javascript:;" className="btn-send"> <i className="icon-alumni-send mx-1"></i></a> */}
                                                </div>
                                            </div>
                                            <CardBottom alumni={alum} state={state} />
                                        </div>
                                    </div>
                                ))}
                             </>
                                 ) : (
                                 <div className="col-12 text-center">
                                  <p>No data available</p>
                                   </div>
                              )}    
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <section
                className="bg-red pt-3 pt-sm-5 pb-3 container-fluid"
                id="alumni_directory"
                data-aos="fade-down"
                style={showSuggestions ? { position: 'relative', zIndex: 1100 } : undefined}>
                <div className="max-1140 mx-auto">
                    <div className="row alumni-directory">
                        <div className="col-lg-12 alumni-directory-header">
                            <div
                                className={`alumni-directory-header_search ${showSuggestions ? 'align-items-start' : ''}`}
                                style={showSuggestions ? { overflow: 'visible' } : undefined}>
                                <h2
                                    data-aos="fade-left"
                                    data-aos-delay="300"
                                    className="font-22 font-600 text-white mb-3 mb-sm-0 me-3 aos-init aos-animate">
                                    Alumni <span className="d-block d-sm-inline-block">Directory</span>
                                </h2>
                                {/* {userTypeCode != 'STUDENT' && ( */}
                                <div
                                    className={`alumni-directorySearch-wrap ${isShowSearch ? 'show' : ''} position-relative`}
                                    style={showSuggestions ? { zIndex: 1100 } : undefined}>
                                    <form className="alumni-directorySearch" onSubmit={(event) => event.preventDefault()}>
                                        <button type="button" className="btn icon-search height-40"></button>
                                        <input
                                            className=" form-control height-40"
                                            type="search"
                                            placeholder="Search by Alumni"
                                            id="SearchStudent"
                                            aria-label="Search"
                                            value={searchName}
                                            onChange={handleNameSearch}
                                            onBlur={handleInputBlur}
                                            onFocus={() => searchName.length > 0 && setShowSuggestions(true)}
                                        />
                                        <a className="btn-cross" id="SearchStudentBtnCross" onClick={handleNameSearchClear}></a>
                                    </form>
                                    {showSuggestions && (
                                        <div
                                            className="suggestions-dropdown bg-white rounded shadow-sm w-100 mt-1 border"
                                            style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: 0,
                                                right: 0,
                                                maxHeight: 180,
                                                overflowY: 'auto',
                                                zIndex: 1100,
                                                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                            }}>
                                            {suggestions.length > 0 ? (
                                                suggestions.map((s) => (
                                                    <div
                                                        key={s.id}
                                                        className="suggestion-item px-3 py-2 cursor-pointer hover-bg-light"
                                                        style={{ cursor: 'pointer', borderBottom: '1px solid #eee' }}
                                                        onMouseDown={() => handleSuggestionClick(s.text)}>
                                                        <div className="font-14 font-500 text-dark">{s.text}</div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="px-3 py-2 text-muted font-14">No matching results</div>
                                            )}
                                        </div>
                                    )}
                                    <a
                                        className="btn-alumniSearchToggle cursor-pointer icon-search d-flex d-sm-none"
                                        onClick={handleSearchToggle}>
                                    </a>
                                </div>
                                {showResetButton && <div className={`alumni-reset-wrap ${isShowSearch ? 'show' : ''}`}>
                                    <button type="button" className="ms-2 btn btn-white-border mt-0" onClick={(e) => handleClearAllFilterClick(e, state, dispatch)}><span>Reset</span></button>
                                </div>}
                                {/* )} */}
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="aldir_scroll active">
                                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5">
                                    {summaryCardsControl.map((control: any) => (
                                        <div key={control.id} className="col mb-4 aldir_box">
                                            <div
                                                className={`bg-white rounded alumni-directory-block h-100 aos-init aos-animate ${getCardBorder(
                                                    control.id
                                                )}`}
                                                data-aos="fade-up"
                                                role="button"
                                                onClick={() => handleSummaryCardClick(control.id)}
                                                data-aos-delay="600">
                                                <div className="number font-28 font-600 d-flex justify-content-between align-items-center">
                                                    {summaryCardsData[control.id] ?? 0}
                                                    {control.tooltip ? (
                                                        <i
                                                            className="bi bi-info-circle-fill defaultTooltip font-16 position-absolute top-10 right-10"
                                                            data-bs-toggle="tooltip"
                                                            title={control.tooltip}
                                                            onClick={(e) => e.stopPropagation()}
                                                        />
                                                    ) : (
                                                        <a className="icon-right-arrow font-14 font-600 text-decoration-none text-dark-blue"></a>
                                                    )}
                                                </div>
                                                <div className="d-flex justify-content-between">
                                                    <div className="font-16 font-500 flex-1">{control.label}</div>
                                                    <div className="alumni-directory-img">
                                                        <img src={control.image} className="img-fluid" alt="Total Joined Alumni" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default DirectorySummaryCardControl;
